// Stub for aico app when embed is disabled
if (typeof aico === 'undefined') { window.aico = {}; }

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.search_reset__button):not(.search-modal__close-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container"
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`
      )
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement)
    );
    const quickBulkElement =
      this.closest("quick-order-list") || this.closest("quick-add-bulk");
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min
        )
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max
        )
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step
        )
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

// $(document).on("click", ".categories-filter-item", function (event) {
//   aico.jq("#aicoCustomSortOption").show();
//   let dataHandle = $(this).attr("data-handle");
//   dataHandle = $(this).attr("data-title");

//   const $filterBtn = $(this).find(".filter-btn");

//   // Check if the button already has the active-filter class
//   if ($filterBtn.hasClass("active-filter")) {
//     $filterBtn.removeClass("active-filter");

//     // Update request_data for no active filter
//     if (typeof request_data !== "undefined") {
//       request_data["collection_handle"] = aico.collecton_handle; // Set collection handle to default
//       delete request_data.page;
//     }

//     console.log("Filter deactivated, setting default collection handle.");
//   } else {
//     // Activate the clicked button and deactivate others
//     $(".categories-filter-item .filter-btn").removeClass("active-filter");
//     $filterBtn.addClass("active-filter");

//     // Ensure request_data is defined
//     if (typeof request_data === "undefined") {
//       console.error("request_data is not defined.");
//       return;
//     }

//     // Update request_data with the selected filter
//     // request_data["collection_handle"] = dataHandle;

//     // if (dataHandle == "sweaterscardigans-79") {
//     //   dataHandle = "Sweaters & Cardigans";
//     // }
//     // if (dataHandle == "denim-pants") {
//     //   dataHandle = "Denim Pants";
//     // }

//     request_data["aico_c_collection"] = [dataHandle];
//     delete request_data.page;
//   }

//   // Perform AJAX request
//   aico.jq.ajax({
//     url: aico.aico_url + "api/filter-data",
//     method: "POST",
//     data: request_data,
//     success: function (response) {
//       console.log(response); // Log the response
//       aico.jq(".aico-filters").removeAttr("style");
//       // Process response
//       removeParamsFromUrl();
//       appendAicoParamsToUrl();
//       aico.jq(".aico-tags").remove();
//       tagsList(response);
//       aico.jq(".collection ul#product-grid").remove();
//       aico.jq(".product__grid-item").remove();
//       productsAppendAfterRespons(response);
//       selectedList(request_data, response);
//       aico.jq(".aico-pagination").remove();
//       makePagination(response.product_count);
//       selectedTagChecked(request_data);
//       aico.jq(".af-filter-message").remove();
//       if (response.total_product == 0) {
//         aico.jq("#aicoCustomSortOption").hide();
//         emptyFunctionLoad();
//       }
//       collectionProductDiscount(response);
//       removeRefineByIflengthIsZero();
//       aico.jq(".aico-collection-append").html("");
//       collectionHtml(response);
//       aico.jq(".aico-metafield-append").html("");
//       metafieldHtml(response);
//       aico.jq(".aico-metafield-value-append").html("");
//       MetafiledValueFilerHtml(response);
//       productOptionsFilters(response);
//       onloadCheckValue(request_data);
//       commonFunctionLoad(response);
//     },
//     error: function (error) {
//       console.error("AJAX request failed:", error); // Log AJAX errors
//     },
//   });
// });

// comment 12 aug
// $(".categories-filter-item .filter-btn").removeClass("active-filter");
// $(document).on("click", ".categories-filter-item", function (event) {
//   event.preventDefault();

//   const $this = $(this);
//   const dataHandle = $this.attr("data-title");
//   const $filterBtn = $this.find(".filter-btn");

//   aico.jq("#aicoCustomSortOption").show();

//   // Ensure request_data is defined
//   if (typeof request_data === "undefined") {
//     console.error("request_data is not defined.");
//     return;
//   }

//   // Toggle active-filter class
//   const isActive = $filterBtn.hasClass("active-filter");

//   if (isActive) {
//     // Remove active state
//     $filterBtn.removeClass("active-filter");
//     // console.log("request_data", request_data);

//     // Reset request_data to default collection handle
//     request_data["collection_handle"] = aico.collecton_handle;
//     delete request_data["aico_c_collection"];
//     delete request_data.page;

//     // console.log("Filter deactivated, setting default collection handle.");
//   } else {
//     // Deactivate others and activate this
//     $(".categories-filter-item .filter-btn").removeClass("active-filter");
//     $filterBtn.addClass("active-filter");

//     // Update request_data with the selected filter
//     request_data["aico_c_collection"] = [dataHandle];
//     delete request_data.page;

//     // console.log("Filter activated:", dataHandle);
//   }

//   // Perform AJAX request
//   aico.jq.ajax({
//     url: aico.aico_url + "api/filter-data",
//     method: "POST",
//     data: request_data,
//     success: function (response) {
//       // console.log(response); // Log the response
//       aico.jq(".aico-filters").removeAttr("style");
//       // Process response
//       removeParamsFromUrl();
//       appendAicoParamsToUrl();
//       aico.jq(".aico-tags").remove();
//       tagsList(response);
//       aico.jq(".collection ul#product-grid").remove();
//       aico.jq(".product__grid-item").remove();
//       productsAppendAfterRespons(response);
//       selectedList(request_data, response);
//       aico.jq(".aico-pagination").remove();
//       makePagination(response.product_count);
//       selectedTagChecked(request_data);
//       aico.jq(".af-filter-message").remove();
//       if (response.total_product == 0) {
//         aico.jq("#aicoCustomSortOption").hide();
//         emptyFunctionLoad();
//       }
//       collectionProductDiscount(response);
//       removeRefineByIflengthIsZero();
//       aico.jq(".aico-collection-append").html("");
//       collectionHtml(response);
//       aico.jq(".aico-metafield-append").html("");
//       metafieldHtml(response);
//       aico.jq(".aico-metafield-value-append").html("");
//       MetafiledValueFilerHtml(response);
//       productOptionsFilters(response);
//       onloadCheckValue(request_data);
//       commonFunctionLoad(response);
//     },
//     error: function (error) {
//       console.error("AJAX request failed:", error);
//     },
//   });
// });

// $(".item-inner .link").attr("href", "");
// $(document).on("click", ".subcategories-item", function (event) {
//   event.preventDefault();
//   aico.jq("#aicoCustomSortOption").show();
//   let dataHandle = $(this).attr("data-handle");
//   dataHandle = $(this).attr("data-title");
//   // console.log(dataHandle);

//   const $filterBtn = $(this).find(".item-inner");

//   // Check if the button already has the active-filter class
//   if ($filterBtn.hasClass("active-filter")) {
//     $filterBtn.removeClass("active-filter");

//     // Update request_data for no active filter
//     if (typeof request_data !== "undefined") {
//       request_data["collection_handle"] = aico.collecton_handle; // Set collection handle to default
//       delete request_data.page;
//     }

//     // console.log("Filter deactivated, setting default collection handle.");
//   } else {
//     // Activate the clicked button and deactivate others
//     $(".subcategories-item .item-inner").removeClass("active-filter");
//     $filterBtn.addClass("active-filter");

//     // Ensure request_data is defined
//     if (typeof request_data === "undefined") {
//       console.error("request_data is not defined.");
//       return;
//     }

//     // if (dataHandle == "denim-pants") {
//     //   dataHandle = "Pants";
//     // }
//     // if (dataHandle == "denim-jeans") {
//     //   dataHandle = "Jeans";
//     // }

//     // Update request_data with the selected filter
//     request_data["aico_c_collection"] = [dataHandle];
//     delete request_data.page;
//   }

//   // Perform AJAX request
//   aico.jq.ajax({
//     url: aico.aico_url + "api/filter-data",
//     method: "POST",
//     data: request_data,
//     success: function (response) {
//       // console.log(response); // Log the response

//       // Process response
//       removeParamsFromUrl();
//       appendAicoParamsToUrl();
//       aico.jq(".aico-tags").remove();
//       tagsList(response);
//       aico.jq(".collection ul#product-grid").remove();
//       aico.jq(".product__grid-item").remove();
//       productsAppendAfterRespons(response);
//       selectedList(request_data, response);
//       aico.jq(".aico-pagination").remove();
//       makePagination(response.product_count);
//       selectedTagChecked(request_data);
//       aico.jq(".af-filter-message").remove();
//       if (response.total_product == 0) {
//         aico.jq("#aicoCustomSortOption").hide();
//         emptyFunctionLoad();
//       }
//       collectionProductDiscount(response);
//       removeRefineByIflengthIsZero();
//       aico.jq(".aico-collection-append").html("");
//       collectionHtml(response);
//       aico.jq(".aico-metafield-append").html("");
//       metafieldHtml(response);
//       aico.jq(".aico-metafield-value-append").html("");
//       MetafiledValueFilerHtml(response);
//       productOptionsFilters(response);
//       onloadCheckValue(request_data);
//       commonFunctionLoad(response);
//     },
//     error: function (error) {
//       console.error("AJAX request failed:", error); // Log AJAX errors
//     },
//   });
// });

$(document).ready(function () {
  // Don't hide breadcrumbs on wishlist page
  var isWishlistPage = window.location.pathname.includes('/pages/wishlist');
  if (!isWishlistPage && $(".breadcrumbs__list li").length === 0) {
    $(".breadcrumbs-section").hide();
  }
});
// const slideDataCache = new Map();
// function loadSwiper(container = document) {
//   // Function to initialize or update Swiper for a specific product card
//   function initializeSwiper(productCard, selectedColor) {
//     const swiperContainer = productCard.querySelector(".mySwiper");
//     const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
//     const nextButton = productCard.querySelector(".swiper-button-next");
//     const prevButton = productCard.querySelector(".swiper-button-prev");
//     const productCardId =
//       productCard.dataset.productId ||
//       `card-${Math.random().toString(36).substr(2, 9)}`;
//     productCard.dataset.productId = productCardId;

//     // Use cached slide data if available, otherwise collect from DOM
//     let allSlides = slideDataCache.get(productCardId);
//     if (!allSlides) {
//       allSlides = Array.from(productCard.querySelectorAll(".swiper-slide")).map(
//         (slide) => ({
//           image_id: slide.getAttribute("image-id"),
//           color_title: slide.querySelector("img").getAttribute("color-title"),
//           src: slide.querySelector("img").getAttribute("src"),
//           alt: slide.querySelector("img").getAttribute("alt"),
//           href: slide.querySelector("a").getAttribute("href"),
//         })
//       );
//       slideDataCache.set(productCardId, allSlides);
//     }

//     // Filter slides by selected color
//     const filteredSlides = allSlides.filter(
//       (slide) => slide.color_title.toLowerCase() === selectedColor.toLowerCase()
//     );
//     // console.log(filteredSlides, selectedColor.toLowerCase());

//     // Clear existing slides
//     swiperWrapper.innerHTML = "";

//     console.log(filteredSlides,'filterslides');

//     // Add filtered slides to the swiper-wrapper
//     filteredSlides.forEach((slide, index) => {
//       const slideElement = document.createElement("div");
//       slideElement.classList.add("swiper-slide");
//       slideElement.setAttribute("image-id", slide.image_id);
//       slideElement.setAttribute("role", "group");
//       slideElement.setAttribute(
//         "aria-label",
//         `${index + 1} / ${filteredSlides.length}`
//       );
//       slideElement.style.width = "305px";
//       slideElement.innerHTML = `
//                 <a href="${slide.href}">
//                     <img color-title="${slide.color_title}" src="${slide.src}" alt="${slide.alt}">
//                 </a>
//             `;
//       swiperWrapper.appendChild(slideElement);
//     });

//     // Destroy existing Swiper instance if it exists
//     if (swiperContainer.swiper) {
//       swiperContainer.swiper.destroy(true, true);
//     }

//     if (filteredSlides.length <= 1) {
//       if (nextButton) nextButton.style.display = "none"; // Added: Hide next button
//       if (prevButton) prevButton.style.display = "none"; // Added: Hide prev button
//     } else {
//       if (nextButton) nextButton.style.display = "block"; // Added: Show next button
//       if (prevButton) prevButton.style.display = "block"; // Added: Show prev button
//     }

//     // Initialize new Swiper instance
//     const swiper = new Swiper(swiperContainer, {
//       slidesPerView: 1,
//       spaceBetween: 0,
//       navigation: {
//         nextEl: nextButton ? nextButton : null, // Added: Ensure valid button reference
//         prevEl: prevButton ? prevButton : null, // Added: Ensure valid button reference
//         disabledClass: "swiper-button-disabled",
//       },
//       on: {
//         init: function () {
//           console.log("Swiper initialized", this, filteredSlides.length); // Added: Debug log for init
//           updateNavigationButtons(this, filteredSlides.length);
//         },
//         slideChange: function () {
//           console.log("slideChange triggered", this, filteredSlides.length); // Modified: Debug log for slideChange
//           updateNavigationButtons(this, filteredSlides.length);
//         },
//       },
//     });

//     // Update ARIA attributes for the swiper wrapper
//     swiperWrapper.setAttribute("aria-live", "polite");
//     swiperWrapper.setAttribute(
//       "id",
//       `swiper-wrapper-${Math.random().toString(36).substr(2, 9)}`
//     );

//     // Store the Swiper instance
//     swiperContainer.swiper = swiper;

//     // Explicitly update navigation buttons after initialization
//     updateNavigationButtons(swiper, filteredSlides.length);
//   }

//   // Function to update navigation button states
//   function updateNavigationButtons(swiper, totalSlides) {
//     const nextButton = swiper.el.querySelector(".swiper-button-next");
//     const prevButton = swiper.el.querySelector(".swiper-button-prev");
//     console.log(prevButton,nextButton,swiper,totalSlides);

//     console.log(nextButton,prevButton);
//     // Handle previous button
//     if (prevButton) {
//       if (swiper.activeIndex === 0 || totalSlides <= 1) {
//         prevButton.classList.add("swiper-button-disabled");
//         prevButton.setAttribute("aria-disabled", "true");
//         prevButton.setAttribute("tabindex", "-1");
//         prevButton.setAttribute("disabled", "disabled");
//       } else {
//         prevButton.classList.remove("swiper-button-disabled");
//         prevButton.setAttribute("aria-disabled", "false");
//         prevButton.setAttribute("tabindex", "0");
//         prevButton.removeAttribute("disabled");
//       }
//     }

//     // Handle next button
//     if (nextButton) {
//       if (swiper.activeIndex === totalSlides - 1 || totalSlides <= 1) {
//         nextButton.classList.add("swiper-button-disabled");
//         nextButton.setAttribute("aria-disabled", "true");
//         nextButton.setAttribute("tabindex", "-1");
//         nextButton.setAttribute("disabled", "disabled");
//       } else {
//         nextButton.classList.remove("swiper-button-disabled");
//         nextButton.setAttribute("aria-disabled", "false");
//         nextButton.setAttribute("tabindex", "0");
//         nextButton.removeAttribute("disabled");
//       }
//     }
//   }

//   // Initialize Swiper for each product card within the container
//   container.querySelectorAll(".af-productCard").forEach((productCard) => {
//     // Skip if already initialized
//     if (productCard.dataset.swiperInitialized) return;
//     productCard.dataset.swiperInitialized = "true";

//     // Get initial active color with fallback
//     const activeColor = productCard
//       .querySelector(".af-color-options .af-active-color")
//       ?.getAttribute("color-title");
//     // console.log(activeColor,'activecolor');
//     if (activeColor) {
//       // initializeSwiper(productCard, activeColor);
//     } else {
//       console.warn("No active color found for product card on initial load", productCard); // Added: Warn if no active color
//     }

//     // Handle color option clicks
//     productCard
//       .querySelectorAll(".af-color-options .color-options")
//       .forEach((colorOption) => {
//         colorOption.addEventListener("click", (e) => {
//           const selectedColor = e.target
//             .closest(".color-options")
//             ?.getAttribute("color-title");
//           // console.log(selectedColor,'selectedColor');

//           if (selectedColor) { // Added: Validate selected color
//             // Update active color class
//             productCard
//               .querySelectorAll(".af-color-options .color-options")
//               .forEach((opt) => {
//                 opt.classList.remove("af-active-color");
//               });
//             e.target.closest(".color-options").classList.add("af-active-color");

//             // Reinitialize Swiper with the selected color
//             // initializeSwiper(productCard, selectedColor);
//           } else {
//             console.error("No color-title found for clicked color option", colorOption); // Added: Error logging
//           }
//         });
//       });
// });
// }

function changeFilterElementLiOrder() {
  const productGrid = document.querySelector(".af-productGrid");
  if (!productGrid) {
    console.warn("Product grid element not found.");
    return;
  }

  const liElements = Array.from(productGrid.children);

  // helper to extract sorting values
  const getSortData = (li, index) => {
    const sortOrder = parseInt(li.getAttribute("color-variant-sort-order") || "0", 10);
    const releaseAttr = li.getAttribute("data-release-start-time");
    const releaseDate = releaseAttr ? new Date(releaseAttr).getTime() : null;
    return {
      element: li,
      originalIndex: index,
      sortOrder,
      releaseDate
    };
  };

  if (liElements.length > 3) {
    const elements = liElements.map(getSortData);

    // preserve 9999
    const preservedElements = elements.filter(item => item.sortOrder === 9999);
    const normalElements = elements.filter(item => item.sortOrder !== 9999);

    // sort: new date first > old date > sortOrder
    const sortedNormal = normalElements.sort((a, b) => {
      if (a.releaseDate && b.releaseDate) {
        return b.releaseDate - a.releaseDate; // NEWEST first
      }
      if (a.releaseDate && !b.releaseDate) return -1; // a has date → first
      if (!a.releaseDate && b.releaseDate) return 1;  // b has date → first
      return a.sortOrder - b.sortOrder; // fallback
    });

    // reconstruct with preserved
    const result = [];
    let sortedIndex = 0;
    for (let i = 0; i < liElements.length; i++) {
      const preserved = preservedElements.find(p => p.originalIndex === i);
      if (preserved) {
        result.push(preserved.element);
      } else if (sortedIndex < sortedNormal.length) {
        result.push(sortedNormal[sortedIndex++].element);
      }
    }

    productGrid.replaceChildren(...result);
  } else {
    // <= 3 simple case
    const elements = liElements.map(getSortData);

    elements.sort((a, b) => {
      if (a.releaseDate && b.releaseDate) {
        return b.releaseDate - a.releaseDate; // NEWEST first
      }
      if (a.releaseDate && !b.releaseDate) return -1;
      if (!a.releaseDate && b.releaseDate) return 1;
      return a.sortOrder - b.sortOrder;
    });

    productGrid.replaceChildren(...elements.map(e => e.element));
  }
}


// Fisher-Yates shuffle
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function noProductFoundHtml() {
  // aico.jq(".af-customSorting").hide();
  aico.jq(".aico-filter-app").addClass('af-no-products');
  aico.jq('.aico-pagination').remove();
  aico.jq('.aico-product-count-display').remove();

  let noProductText = "No products found";
  let resetFilterText = "Reset filters";

  if (Shopify.locale == "fr") {
    noProductText = "Aucun produit trouvé";
    resetFilterText = "Réinitialiser les filtres";
  }

  if (Shopify.locale == "it") {
    noProductText = "Nessun prodotto trovato";
    resetFilterText = "Reimposta i filtri";
  }

  if (Shopify.locale == "de") {
    noProductText = "Keine Produkte gefunden";
    resetFilterText = "Filter zurücksetzen";
  }


  let htmlnoProduct = `<div class="aico-no-product-found af-filter-message">
<div class="af-np-svg"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#9A9A9A"/>
<path d="M18.125 28.625C17.4219 28.625 16.875 29.2109 16.875 29.875C16.875 30.5781 17.4219 31.125 18.125 31.125C18.7891 31.125 19.375 30.5781 19.375 29.875C19.375 29.2109 18.7891 28.625 18.125 28.625ZM21.0938 28.9375H34.0625C34.5703 28.9375 35 29.3672 35 29.875C35 30.4219 34.5703 30.8125 34.0625 30.8125H21.0938C20.7031 32.1016 19.4922 33 18.125 33C16.3672 33 15 31.6328 15 29.875C15 28.1562 16.3672 26.75 18.125 26.75C19.4922 26.75 20.7031 27.6875 21.0938 28.9375ZM30.625 21.125C30.625 21.8281 31.1719 22.375 31.875 22.375C32.5391 22.375 33.125 21.8281 33.125 21.125C33.125 20.4609 32.5391 19.875 31.875 19.875C31.1719 19.875 30.625 20.4609 30.625 21.125ZM28.8672 20.1875C29.2578 18.9375 30.4688 18 31.875 18C33.5938 18 35 19.4062 35 21.125C35 22.8828 33.5938 24.25 31.875 24.25C30.4688 24.25 29.2578 23.3516 28.8672 22.0625H15.9375C15.3906 22.0625 15 21.6719 15 21.125C15 20.6172 15.3906 20.1875 15.9375 20.1875H28.8672Z" fill="#9A9A9A"/>
</svg></div>
<div class="aico-no-product-found-text">${noProductText}</div>
<div class="aico-reset-filter clear-all-filter">
<span class="aico-reset-filter-icon"><svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.3125 5H0.875V4.5625V1.0625V0.625H1.75V1.0625V3.60547C2.81641 1.82812 4.75781 0.625 7 0.625C10.3633 0.625 13.125 3.38672 13.125 6.75C13.125 10.1406 10.3633 12.875 7 12.875C4.62109 12.875 2.57031 11.5352 1.55859 9.59375L2.32422 9.18359C3.19922 10.8789 4.94922 12 7 12C9.89844 12 12.25 9.64844 12.25 6.75C12.25 3.85156 9.89844 1.5 7 1.5C5.05859 1.5 3.33594 2.56641 2.43359 4.125H4.8125H5.25V5H4.8125H1.3125Z" fill="#7C6750"/>
</svg>
</span>
<span class="aico-reset-filter-text">${resetFilterText}</span>
</div>
</div>`;
  return htmlnoProduct;
}

function moveRefineBy() {
  if (window.innerWidth >= 1025) {
    $(".aico-filter-refine-by").appendTo(".aico-filters");
  } else {
    $(".aico-filter-refine-by").insertAfter(".product-grid-close");
  }
}
window.addEventListener("resize", moveRefineBy);

function refindMobileHtml(filterCount, resultsCount) {

  let showResultText = `Show ${resultsCount} results`;

  if(resultsCount == 1) {
    showResultText = `Show ${resultsCount} result`;
  }
  let resetFilterText = "Reset filters";
  let emptybtnText = "0 Result";
  // resultsCount = 0;

  if (Shopify.locale == "fr") {
    if(resultsCount > 1) {
      showResultText = `Afficher ${resultsCount} résultats`;
    } else {
      showResultText = `Mostra ${resultsCount} résultat`;
    }
    resetFilterText = "Réinitialiser les filtres";
    emptybtnText = "0 Résultat";
  }

  if (Shopify.locale == "it") {
    if(resultsCount > 1) {
      showResultText = `Mostra ${resultsCount} risultati`;
    } else {
      showResultText = `Mostra ${resultsCount} risultato`;
    }
    resetFilterText = "Reimposta i filtri";
    emptybtnText = "0 Risultato";
  }

  if (Shopify.locale == "de") {
    if(resultsCount > 1) {
      showResultText = `${resultsCount} Ergebnisse anzeigen`;
    } else {
      showResultText = `${resultsCount} Ergebnis anzeigen`;
    }
    resetFilterText = "Zurücksetzen";
    emptybtnText = "0 Ergebnis";
  }

  let htmlrefine = `<div class="aico-filter-refine-mobile ${
    resultsCount == 0 ? "af-result-zero" : "af-result-present"
  }">
    <div class="aico-reset-filter-wrapper">
      <button class="aico-reset-button clear-all-filter">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 4.3125L9.125 0.15625L9.84375 0.875L5.6875 5L9.84375 9.15625L9.125 9.875L5 5.71875L0.84375 9.875L0.125 9.15625L4.28125 5L0.125 0.875L0.84375 0.15625L5 4.3125Z" fill="#7C6750"/>
        </svg>
        ${resetFilterText}
      </button>
      ${
        resultsCount != 0
          ? `<button class="aico-show-all-result-button">${showResultText}</button>`
          : `<button class="af-filter-result-not-found">${emptybtnText}</button>`
      }
    </div>
  </div>`;

  aico.jq(".aico-filter-refine-mobile").remove();
  aico.jq(".aico-filters").append(htmlrefine);
}

function checkMobileGrosseOption() {
  checkMaterial();
}

window.addEventListener("resize", checkMobileGrosseOption);

function checkMaterial() {
  if (window.innerWidth < 1025) {
    if (
      $(".material_usage .aico-metafield-value-filter-input:checked").length > 0
    ) {
      let shownumberHtml = `<div class="af-material-option-count">${
        $(".material_usage .aico-metafield-value-filter-input:checked").length
      }</div>`;
      $(".af-material-option-count").remove();
      $(".material_usage  .aico-specific-clear").before(shownumberHtml);
    } else {
      $(".af-material-option-count").remove();
    }

    if (
      $(".style .aico-metafield-value-filter-input:checked").length > 0
    ) {
      let shownumberHtml = `<div class="af-style-option-count">${
        $(".style .aico-metafield-value-filter-input:checked").length
      }</div>`;
      $(".af-style-option-count").remove();
      $(".style  .aico-specific-clear").before(shownumberHtml);
    } else {
      $(".af-style-option-count").remove();
    }

    if (
      $(".af-filter-size .aico-product-option-input:checked").length > 0
    ) {
      let shownumberHtml = `<div class="af-grosse-option-count">${
        $(".af-filter-size .aico-product-option-input:checked").length
      }</div>`;
      $(".af-grosse-option-count").remove();
      $(".af-filter-size .aico-specific-clear").before(shownumberHtml);
    } else {
      $(".af-grosse-option-count").remove();
    }

    if ($(".aico-filter-refine-by-items").length == 0) {
      $(".aico-filter-refine-mobile").remove();
    }
  }
}

window.addEventListener("resize", checkMaterial);

function triggerCustomSelect() {
  aico.jq("#afCustomSort .af-sort-custom-option").each(function () {
    if (aico.jq(this).attr("value") === "0") {
      // aico.jq(this).trigger("click");
      // return false;
    }
  });
}

$(document).ready(function () {
  if ($(".announcement-bar").length) {
    $("body").addClass("announcement-bar-persent");
  }
if (aico.aico_price_list_customer || aico.aico_discount_list_customer) {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
        aico.aico_shopify_cart = cart;
        aicoCartPriceListUpdate(cart);
    });
}

  $(document).on("click", ".aico-mb-button", function () {
    $("body").addClass("mb-filter-open");
  });
  $(document).on("click", ".aico-close-icon", function () {
    $("body").removeClass("mb-filter-open");
  });
  
  $(document).on("click", "a[href*='/account']", function() {
    console.log('Account link clicked - sending profile to Klaviyo');
    setTimeout(() => {
      sendCustomerProfileToKlaviyo();
    }, 100);
  });
});


async function sendCustomerProfileToKlaviyo() {
  if (window.customerAPIUtils && window.customerAPIUtils.currentCustomerData) {
    try {
      await window.customerAPIUtils.sendLobsterProfileToShopify();
    } catch (error) {
      console.error('Error sending customer profile to Klaviyo from account link:', error);
    }
  } else {

    const nileCard = document.getElementById('nile-card-number')?.value;
    if (nileCard && window.customerAPIUtils) {
      try {
        const customerData = await window.customerAPIUtils.fetchCustomerData(nileCard);
        if (customerData) {
          await window.customerAPIUtils.sendLobsterProfileToShopify();
        }
      } catch (error) {
        console.error('Error fetching and sending customer profile to Klaviyo from account link:', error);
      }
    }
  }
}

window.addEventListener("cart_changed", function (e) {
  if (e.type == "cart_changed") {
    let cart = aico.aico_shopify_cart;
    if (aico.aico_price_list_customer || aico.aico_discount_list_customer) {
      aicoCartPriceListUpdate(cart, e.detail);
    } else {
      // console.log("aico_discount_list_customer not active");
    }
    setTimeout(function () {
      let cart = aico.aico_shopify_cart;
      if (aico.aico_price_list_customer || aico.aico_discount_list_customer) {
        aicoCartPriceListUpdate(cart, e.detail);
      } else {
        // console.log("aico_discount_list_customer not active");
      }
    }, 300);
  }
});

if (window.location.pathname !== "/cart") {
  aicoCartPriceDiscount();
  // console.log("This is NOT the cart page");
}

function aicoCartPriceDiscount() {
  $(document).on("click", "#CartDrawer-Checkout", function (e) {
    if (window.aico_discounts_process) {
      return; // Exit if already processing
    }
    window.aico_discounts_process = true; // Set flag immediately
    e.preventDefault(); // Prevent default action

    var that = $(this);
    that.prop("disabled", true); // Disable checkout button

    var cart = aico.aico_shopify_cart;
    var is_price_discount_list_applied = false;

    if (aico.aico_price_list_customer || aico.aico_discount_list_customer) {
      var cart_products = [];

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var varId = item.variant_id;
        var itemPrice = item.price / 100; // Convert cents to base currency

        var aico_price_object = {
          properties: [],
          variant_id: varId,
          original_price: item.price,
          quantity: item.quantity,
        };

        for (const property in item.properties) {
          if (property === "_price_item_discount") {
            let propertyValue = parseFloat(
              item.properties[property].replace(/,/g, "")
            );

            // console.log(
            //   "Comparing propertyValue:",
            //   propertyValue,
            //   "with itemPrice:",
            //   itemPrice
            // );

            if (propertyValue !== itemPrice) {
              // console.log(
              //   "Price mismatch found, applying discount for variant:",
              //   varId
              // );
              is_price_discount_list_applied = true;
              aico_price_object.discounted_price = parseFloat(
                cart.items[i].properties[property].replace(/,/g, "")
              );
            } else {
              // console.log(
              //   "Property value matches item price, no discount needed for variant:",
              //   varId
              // );
            }
          }

          // Push all properties regardless of comparison
          aico_price_object.properties.push({
            [property]: item.properties[property],
          });
        }

        cart_products.push({ [varId]: aico_price_object });
      }

      let cart_note = cart.note || $("#Cart-note").val() || "";

      if (is_price_discount_list_applied) {
        var shop_domain = Shopify.shop;
        var sendData = {
          shop_domain: shop_domain,
          customer_id: aico.login_customer_id,
          cart_products: cart_products,
          currency: cart.currency,
          locale: Shopify.locale,
          token: cart.token,
          cart_attributes: cart.attributes,
          cart_note: cart_note,
        };

        $.ajax({
          type: "POST",
          url: aico.aico_url + "api/discount-code-generate",
          async: true,
          data: sendData,
          dataType: "json",
          success: function (data) {
            if (data.status === 1 && data.checkout_url) {
              window.location = data.checkout_url;
            } else {
              console.error("AICO: Unable to create checkout", data);
              defaultCheckout(that);
            }
          },
          error: function (xhr, status, error) {
            console.error("AICO: AJAX error", status, error);
            defaultCheckout(that);
          },
          complete: function () {
            that.prop("disabled", false); // Re-enable button
            window.aico_discounts_process = false; // Reset flag
          },
        });
      } else {
        // console.log(
        //   "No price mismatch found, proceeding with default checkout."
        // );
        defaultCheckout(that);
      }
    } else {
      // console.log(
      //   "No price list or discount list customer found, proceeding with default checkout."
      // );
      defaultCheckout(that);
    }
  });
}

function defaultCheckout(that) {
  window.aico_discounts_process = true;
  that.attr("name", "checkout");
  that.attr("disabled", false);
  that.trigger("click");
}

function aicoCartPriceListUpdate(cart, cartChanges = null) {
  if (cart.items.length > 0) {
    var total_price = 0;
    var item_total_price = 0;
    const number_options = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    var cart_discounts = "";
    let item_discounted = false;
    for (var a = 0; a < cart.items.length; a++) {
      var id = cart.items[a].id;
      item_discounted = false;
      let cart_properties = cart.items[a].properties;
      if (
        typeof cart.items[a].properties != "undefined" &&
        cart.items[a].properties != null &&
        Object.keys(cart.items[a].properties).length &&
        cart_properties.hasOwnProperty("_price_item_discount")
      ) {
        for (const property in cart.items[a].properties) {
          if (property == "_price_item_discount") {
            item_discounted = true;
            item_total_price =
              parseFloat(cart.items[a].properties[property].replace(/,/g, "")) *
              parseFloat(cart.items[a].quantity);
            if (
              typeof aico.display_product_prices_without_taxes != "undefined" &&
              aico.display_product_prices_without_taxes == "true"
            ) {
              item_total_price =
                item_total_price / (1 + aico.tax_percentage / 100);
              item_total_price = item_total_price.toFixed(2);
              item_total_price = parseFloat(item_total_price);
            }

            item_total_price = Number(item_total_price).toLocaleString(
              "en",
              number_options
            );
            aico
              .jq(`#CartDrawer-Item-${a + 1}`)
              .find(".price")
              .html(cart.currency + " " + item_total_price);

            // console.log("trtrttt44", item_total_price);

            var aico_single_item_amount = parseFloat(
              cart.items[a].properties[property].replace(/,/g, "")
            );
            aico_single_item_amount = Number(
              aico_single_item_amount
            ).toLocaleString("en", number_options);

            total_price =
              total_price +
              parseFloat(cart.items[a].properties[property].replace(/,/g, "")) *
                parseFloat(cart.items[a].quantity);
          }
        }
      }

      if (item_discounted === false) {
        total_price =
          total_price + parseFloat(cart.items[a].final_line_price) / 100;
      }
    }

    aico
      .jq("p.af-cart-total")
      .html(
        cart.currency +
          " " +
          Number(total_price).toLocaleString("en", number_options)
      );
  }
}



// 1 function cNileCopy(collections, vendor, prodata) {
//     console.log('collections', collections);
//     console.log('vendor', vendor);
//     console.log('prodata', prodata);

//     var collections = (collections || '').split(','),
//         discount_group = aico.aico_login_customer_discount_metafield,
//         percentage_discount = 0,
//         pTag = (prodata.product_tags || '').split(',');
//     if (discount_group.hasOwnProperty('rules') && discount_group.rules != '') {
//         var rules = discount_group.rules;
//         Object.keys(rules).forEach(key => {
//             var rule = rules[key],
//                 arrt = rule.rule_type,
//                 rule_date = new Date(rule.expiration_date);

//                 const current_date = new Date();
//                 const formatted_date =
//                     current_date.getFullYear() +
//                     "-" +
//                     String(current_date.getMonth() + 1).padStart(2, "0") +
//                     "-" +
//                     String(current_date.getDate()).padStart(2, "0") +
//                     " " +
//                     String(current_date.getHours()).padStart(2, "0") +
//                     ":" +
//                     String(current_date.getMinutes()).padStart(2, "0") +
//                     ":" +
//                     String(current_date.getSeconds()).padStart(2, "0");


//             if (rule_date >= current_date || rule.expiration_date == null || rule.expiration_date == '') {

//                 if (arrt === "all") percentage_discount += parseFloat(rule.percentage);

//                 if (arrt === 'brand') rule.rule_condition == 'equal' && rule.rule_value == vendor ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && rule.rule_value != vendor && (percentage_discount += parseFloat(rule.percentage));
//                 if (arrt === 'collection') rule.rule_condition == 'equal' && collections.includes(rule.rule_value.trim()) ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && !collections.includes(rule.rule_value.trim()) && (percentage_discount += parseFloat(rule.percentage));
//                 if (arrt === lc) percentage_discount = parseFloat(rule.percentage);
//                 if (arrt === 'custom') {
//                     var customRules = rule.rules;

//                     // Group rules by rule_type
//                     var rulesByType = {};
//                     customRules.forEach(customRule => {
//                         var ruleType = customRule.rule_type;
//                         if (!rulesByType[ruleType]) {
//                             rulesByType[ruleType] = [];
//                         }
//                         rulesByType[ruleType].push(customRule);
//                     });

//                     // Evaluate each group with OR logic, then combine groups with AND
//                     var allGroupsMatch = true;
//                     Object.keys(rulesByType).forEach(ruleType => {
//                         var groupRules = rulesByType[ruleType];
//                         var groupMatches = false; // OR within group

//                         groupRules.forEach(customRule => {
//                             var ruleMatches = false;

//                             if (customRule.rule_type === 'collection' || customRule.rule_type === 'category') {
//                                 var collectionMatch = collections.includes(customRule.rule_value.trim()),
//                                     categoryTag = `${customRule.rule_value.trim()}`,
//                                     categoryMatch = pTag.includes(categoryTag);
//                                 categoryMatch && (collectionMatch = categoryMatch);

//                                 if (customRule.rule_condition === 'equal') {
//                                     ruleMatches = collectionMatch;
//                                 } else if (customRule.rule_condition === 'not_equal') {
//                                     ruleMatches = !collectionMatch;
//                                 }
//                             } else if (customRule.rule_type === 'tag') {
//                                 const tagMatch = pTag.includes(customRule.rule_value.trim());
//                                 if (customRule.rule_condition === 'equal') {
//                                     ruleMatches = tagMatch;
//                                 } else if (customRule.rule_condition === 'not_equal') {
//                                     ruleMatches = !tagMatch;
//                                 }
//                             } else if (customRule.rule_type === 'product') {
//                                 const pmatch = String(prodata?.p_id).trim() === String(customRule.rule_value).trim();
//                                 if (customRule.rule_condition === 'equal') {
//                                     ruleMatches = pmatch;
//                                 } else if (customRule.rule_condition === 'not_equal') {
//                                     ruleMatches = !pmatch;
//                                 }
//                             }

//                             // OR logic within the same rule type group
//                             groupMatches = groupMatches || ruleMatches;
//                         });

//                         // AND logic between different rule type groups
//                         allGroupsMatch = allGroupsMatch && groupMatches;
//                     });

//                     allGroupsMatch && (percentage_discount += parseFloat(rule.percentage))
//                 }
//             }
//         })
//     }
//     return percentage_discount

// }

// 2 function cNileCopy(collections, vendor, prodata) {
//     console.log('collections', collections);
//     console.log('vendor', vendor);
//     console.log('prodata', prodata);

//     var collections = (collections || '').split(','),
//         discount_group = aico.aico_login_customer_discount_metafield,
//         percentage_discount = 0,
//         pTag = (prodata.product_tags || '').split(',');
//     if (discount_group.hasOwnProperty('rules') && discount_group.rules != '') {
//         var rules = discount_group.rules;
//         Object.keys(rules).forEach(key => {
//             var rule = rules[key],
//                 arrt = rule.rule_type,
//                 rule_date = new Date(rule.expiration_date);

//                 const current_date = new Date();
//                 const formatted_date =
//                     current_date.getFullYear() +
//                     "-" +
//                     String(current_date.getMonth() + 1).padStart(2, "0") +
//                     "-" +
//                     String(current_date.getDate()).padStart(2, "0") +
//                     " " +
//                     String(current_date.getHours()).padStart(2, "0") +
//                     ":" +
//                     String(current_date.getMinutes()).padStart(2, "0") +
//                     ":" +
//                     String(current_date.getSeconds()).padStart(2, "0");


//             if (rule_date >= current_date || rule.expiration_date == null || rule.expiration_date == '') {

//                 if (arrt === "all") percentage_discount += parseFloat(rule.percentage);

//                 if (arrt === 'brand') rule.rule_condition == 'equal' && rule.rule_value == vendor ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && rule.rule_value != vendor && (percentage_discount += parseFloat(rule.percentage));
//                 if (arrt === 'collection') rule.rule_condition == 'equal' && collections.includes(rule.rule_value.trim()) ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && !collections.includes(rule.rule_value.trim()) && (percentage_discount += parseFloat(rule.percentage));
//                 if (arrt === lc) percentage_discount = parseFloat(rule.percentage);
//                 if (arrt === 'custom') {
//                     var customRules = rule.rules;

//                     // Check if product_id matches any not_equal product rule - if so, skip this discount
//                     var productExcluded = false;
//                     customRules.forEach(customRule => {
//                         if (customRule.rule_type === 'product' && customRule.rule_condition === 'not_equal') {
//                             const pmatch = String(prodata?.p_id).trim() === String(customRule.rule_value).trim();
//                             if (pmatch) {
//                                 productExcluded = true;
//                             }
//                         }
//                     });

//                     // If product is excluded, skip this rule entirely
//                     if (!productExcluded) {
//                         // Group rules by rule_type
//                         var rulesByType = {};
//                         customRules.forEach(customRule => {
//                             var ruleType = customRule.rule_type;
//                             if (!rulesByType[ruleType]) {
//                                 rulesByType[ruleType] = [];
//                             }
//                             rulesByType[ruleType].push(customRule);
//                         });

//                         // Evaluate each group with OR logic, then combine groups with AND
//                         var allGroupsMatch = true;
//                         Object.keys(rulesByType).forEach(ruleType => {
//                             var groupRules = rulesByType[ruleType];
//                             var groupMatches = false; // OR within group

//                             groupRules.forEach(customRule => {
//                                 var ruleMatches = false;

//                                 if (customRule.rule_type === 'collection' || customRule.rule_type === 'category') {
//                                     var collectionMatch = collections.includes(customRule.rule_value.trim()),
//                                         categoryTag = `${customRule.rule_value.trim()}`,
//                                         categoryMatch = pTag.includes(categoryTag);
//                                     categoryMatch && (collectionMatch = categoryMatch);

//                                     if (customRule.rule_condition === 'equal') {
//                                         ruleMatches = collectionMatch;
//                                     } else if (customRule.rule_condition === 'not_equal') {
//                                         ruleMatches = !collectionMatch;
//                                     }
//                                 } else if (customRule.rule_type === 'tag') {
//                                     const tagMatch = pTag.includes(customRule.rule_value.trim());
//                                     if (customRule.rule_condition === 'equal') {
//                                         ruleMatches = tagMatch;
//                                     } else if (customRule.rule_condition === 'not_equal') {
//                                         ruleMatches = !tagMatch;
//                                     }
//                                 } else if (customRule.rule_type === 'product') {
//                                     const pmatch = String(prodata?.p_id).trim() === String(customRule.rule_value).trim();
//                                     if (customRule.rule_condition === 'equal') {
//                                         ruleMatches = pmatch;
//                                     } else if (customRule.rule_condition === 'not_equal') {
//                                         ruleMatches = !pmatch;
//                                     }
//                                 }

//                                 // OR logic within the same rule type group
//                                 groupMatches = groupMatches || ruleMatches;
//                             });

//                             // AND logic between different rule type groups
//                             allGroupsMatch = allGroupsMatch && groupMatches;
//                         });

//                         allGroupsMatch && (percentage_discount += parseFloat(rule.percentage))
//                     }
//                 }
//             }
//         })
//     }
//     return percentage_discount

// }

function cNileCopy(collections, vendor, prodata) {
    console.log('collections', collections);
    console.log('vendor', vendor);
    console.log('prodata', prodata);

    var collections = (collections || '').split(','),
        discount_group = aico.aico_login_customer_discount_metafield,
        percentage_discount = 0,
        pTag = (prodata.product_tags || '').split(','),
        matchingCustomDiscounts = [], // Array to collect matching custom rule percentages
        customRuleMatches = []; // Array to store {count: number of matching rule types, percentage: discount}
    if (discount_group.hasOwnProperty('rules') && discount_group.rules != '') {
        var rules = discount_group.rules;
        Object.keys(rules).forEach(key => {
            var rule = rules[key],
                arrt = rule.rule_type,
                rule_date = new Date(rule.expiration_date);

                const current_date = new Date();
                const formatted_date =
                    current_date.getFullYear() +
                    "-" +
                    String(current_date.getMonth() + 1).padStart(2, "0") +
                    "-" +
                    String(current_date.getDate()).padStart(2, "0") +
                    " " +
                    String(current_date.getHours()).padStart(2, "0") +
                    ":" +
                    String(current_date.getMinutes()).padStart(2, "0") +
                    ":" +
                    String(current_date.getSeconds()).padStart(2, "0");


            if (rule_date >= current_date || rule.expiration_date == null || rule.expiration_date == '') {

                if (arrt === "all") percentage_discount += parseFloat(rule.percentage);

                if (arrt === 'brand') rule.rule_condition == 'equal' && rule.rule_value == vendor ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && rule.rule_value != vendor && (percentage_discount += parseFloat(rule.percentage));
                if (arrt === 'collection') rule.rule_condition == 'equal' && collections.includes(rule.rule_value.trim()) ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && !collections.includes(rule.rule_value.trim()) && (percentage_discount += parseFloat(rule.percentage));
                if (arrt === lc) percentage_discount = parseFloat(rule.percentage);
                if (arrt === 'custom') {
                    var customRules = rule.rules;

                    // Check if product_id matches any not_equal product rule - if so, skip this discount
                    var productExcluded = false;
                    customRules.forEach(customRule => {
                        if (customRule.rule_type === 'product' && customRule.rule_condition === 'not_equal') {
                            const pmatch = String(prodata?.p_id).trim() === String(customRule.rule_value).trim();
                            if (pmatch) {
                                productExcluded = true;
                            }
                        }
                    });

                    // If product is excluded, skip this rule entirely
                    if (!productExcluded) {
                        // Group rules by rule_type (and for product rules, also by condition type)
                        var rulesByType = {};
                        customRules.forEach(customRule => {
                            var ruleType = customRule.rule_type;
                            // For product rules, group by condition type (equal/not_equal) to handle OR logic properly
                            if (ruleType === 'product') {
                                var productKey = ruleType + '_' + customRule.rule_condition;
                                if (!rulesByType[productKey]) {
                                    rulesByType[productKey] = [];
                                }
                                rulesByType[productKey].push(customRule);
                            } else {
                                if (!rulesByType[ruleType]) {
                                    rulesByType[ruleType] = [];
                                }
                                rulesByType[ruleType].push(customRule);
                            }
                        });

                        // Count how many individual rules match (count each matching rule, not just rule types)
                        // Note: not_equal product rules are exclusion-only and should not be counted
                        var matchingRuleTypeCount = 0;
                        Object.keys(rulesByType).forEach(ruleType => {
                            var groupRules = rulesByType[ruleType];

                            groupRules.forEach(customRule => {
                                // Skip not_equal product rules - they're exclusion-only and already handled above
                                if (customRule.rule_type === 'product' && customRule.rule_condition === 'not_equal') {
                                    return; // Skip this rule
                                }

                                var ruleMatches = false;

                                if (customRule.rule_type === 'collection' || customRule.rule_type === 'category') {
                                    var collectionMatch = collections.includes(customRule.rule_value.trim()),
                                        categoryTag = `${customRule.rule_value.trim()}`,
                                        categoryMatch = pTag.includes(categoryTag);
                                    categoryMatch && (collectionMatch = categoryMatch);

                                    if (customRule.rule_condition === 'equal') {
                                        ruleMatches = collectionMatch;
                                    } else if (customRule.rule_condition === 'not_equal') {
                                        ruleMatches = !collectionMatch;
                                    }
                                } else if (customRule.rule_type === 'tag') {
                                    const tagMatch = pTag.includes(customRule.rule_value.trim());
                                    if (customRule.rule_condition === 'equal') {
                                        ruleMatches = tagMatch;
                                    } else if (customRule.rule_condition === 'not_equal') {
                                        ruleMatches = !tagMatch;
                                    }
                                } else if (customRule.rule_type === 'product') {
                                    const pmatch = String(prodata?.p_id).trim() === String(customRule.rule_value).trim();
                                    if (customRule.rule_condition === 'equal') {
                                        ruleMatches = pmatch;
                                    }
                                }

                                // Count each matching rule
                                if (ruleMatches) {
                                    matchingRuleTypeCount++;
                                }
                            });
                        });

                        // Store the count and percentage for this custom rule
                        if (matchingRuleTypeCount > 0) {
                            customRuleMatches.push({
                                count: matchingRuleTypeCount,
                                percentage: parseFloat(rule.percentage)
                            });
                        }
                    }
                }
            }
        })
    }

    // For custom rules: find the rule with highest matching count, or lowest percentage if tie
    if (customRuleMatches.length > 0) {
        // Sort by count (descending), then by percentage (ascending) for ties
        customRuleMatches.sort(function(a, b) {
            if (b.count !== a.count) {
                return b.count - a.count; // Higher count first
            }
            return a.percentage - b.percentage; // Lower percentage first if tie
        });

        // Use the first one (highest count, or lowest percentage if tie)
        percentage_discount += customRuleMatches[0].percentage;
    } else if (matchingCustomDiscounts.length > 0) {
        // Fallback for old logic (shouldn't be needed, but keeping for safety)
        percentage_discount += Math.min(...matchingCustomDiscounts);
    }

    return percentage_discount

}




function checkConditionMet(cdMet, pmatch, customRule, operator) {if (customRule.rule_condition === 'equal') {if (operator === 'AND') {cdMet = cdMet && pmatch;} else {cdMet = cdMet || pmatch;}} else if (customRule.rule_condition === 'not_equal') {if (operator === 'AND') {cdMet = cdMet && !pmatch;} else {cdMet = cdMet || !pmatch;}}return cdMet;}

    function cNile(collections, vendor, prodata) {
      // console.log('collections33', collections);
      // if(aico.login_customer_id == '8281759056100' || aico.login_customer_id == '8276841332964' || aico.login_customer_id == '25056761577803'){
        return cNileCopy(collections, vendor, prodata);
      // }

        var collections = (collections || '').split(','),
            discount_group = aico.aico_login_customer_discount_metafield,
            percentage_discount = 0,
            pTag = (prodata.product_tags || '').split(',');
        if (discount_group.hasOwnProperty('rules') && discount_group.rules != '') {
            var rules = discount_group.rules;
            Object.keys(rules).forEach(key => {
                var rule = rules[key],
                    arrt = rule.rule_type,
                    rule_date = new Date(rule.expiration_date);

                    const current_date = new Date();
                    const formatted_date =
                  current_date.getFullYear() +
                  "-" +
                  String(current_date.getMonth() + 1).padStart(2, "0") +
                  "-" +
                  String(current_date.getDate()).padStart(2, "0") +
                  " " +
                  String(current_date.getHours()).padStart(2, "0") +
                  ":" +
                  String(current_date.getMinutes()).padStart(2, "0") +
                  ":" +
                  String(current_date.getSeconds()).padStart(2, "0");


                if (rule_date >= current_date || rule.expiration_date == null || rule.expiration_date == '') {

                    if (arrt === "all") percentage_discount += parseFloat(rule.percentage);

                    if (arrt === 'brand') rule.rule_condition == 'equal' && rule.rule_value == vendor ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && rule.rule_value != vendor && (percentage_discount += parseFloat(rule.percentage));
                    if (arrt === 'collection') rule.rule_condition == 'equal' && collections.includes(rule.rule_value.trim()) ? percentage_discount += parseFloat(rule.percentage) : rule.rule_condition == 'not_equal' && !collections.includes(rule.rule_value.trim()) && (percentage_discount += parseFloat(rule.percentage));
                    if (arrt === lc) percentage_discount = parseFloat(rule.percentage);
                    if (arrt === 'custom') {
                        var customRules = rule.rules,
                            operator = rule.operator || 'AND',
                            cdMet = operator === 'AND';
                        customRules.forEach(customRule => {
                            if (customRule.rule_type === 'collection' || customRule.rule_type === 'category') {
                                var collectionMatch = collections.includes(customRule.rule_value.trim()),
                                    categoryTag = `${customRule.rule_value.trim()}`,
                                    categoryMatch = pTag.includes(categoryTag);
                                categoryMatch && (collectionMatch = categoryMatch);
                                customRule.rule_condition === 'equal' ? operator === 'AND' ? cdMet = cdMet && collectionMatch : operator === 'OR' && (cdMet = cdMet || collectionMatch) : customRule.rule_condition === 'not_equal' && (operator === 'AND' ? cdMet = cdMet && !collectionMatch : operator === 'OR' && (cdMet = cdMet || !collectionMatch))
                            }
                            if (customRule.rule_type === 'tag') {
                                const tagMatch = pTag.includes(customRule.rule_value.trim());
                                cdMet = checkConditionMet(cdMet, tagMatch, customRule, operator);
                            }
                            if (customRule.rule_type === 'product') {
                                const pmatch = String(prodata?.p_id).trim() === String(customRule.rule_value).trim();
                                cdMet = checkConditionMet(cdMet, pmatch, customRule, operator);
                            }
                            let ctype = customRule.rule_type;
                            if (ctype != 'product' && ctype != 'collection' && ctype != 'category' && ctype != 'tag') {

                                cdMet = false;
                            }
                        });
                        cdMet && (percentage_discount += parseFloat(rule.percentage))
                    }
                }
            })
        }
        return percentage_discount

    }


